export enum VehicleCategoryTypes {
  TRUCK_2000KG = 'TRUCK_2000KG',
  TRUCK_4000KG = 'TRUCK_4000KG',
  TRUCK_10000KG = 'TRUCK_10000KG',
  TRUCK_18000KG = 'TRUCK_18000KG',
  TRUCK_40000KG = 'TRUCK_40000KG',
  TRUCK_OVER_40000KG = 'TRUCK_OVER_40000KG'
}

export enum ContainerTypes {
  SEPARATED_CONTAINER = 'SEPARATED_CONTAINER',
  STICKY_CONTAINER = 'STICKY_CONTAINER'
}

export enum CoveringContainerLevel {
  PRIVATE = 'PRIVATE',
  OPEN = 'OPEN',
  EMPTY = ''
}

export enum GoodsTypes {
  LIQUID = 'LIQUID',
  SOLID = 'SOLID',
  GAS = 'GAS',
  EMPTY = ''
}

export enum PluginType {
  MOOC = 'MOOC',
  OIL = 'OIL',
  WHEEL = 'WHEEL',
  GENERATOR = 'GENERATOR',
  CONTAINER = 'CONTAINER',
  CHARGE = 'CHARGE'
}

export interface ITollStation {
  calculatedBy: string
  from: string
  to: string
  tollStation: string
  tollStationName: string
  tollStationDetail?: any
}

export interface IVehicleDocument {
  document: undefined
  fileName: undefined
  type: undefined
  privacy: string
  description: undefined
  expiredDate: undefined
  insurancePrice: number | null
}
export interface IMaintenance {
  from: Number
  to: Number
  value: Number
}

export interface IVehicleCategory {
  name: String
  from: Number | undefined
  to: Number | undefined
  wheelNumber: Number | undefined
  priceTires: Number | undefined
  depreciationTires: Number | undefined
  repairingPrice: Number | undefined
  description: String
}

export interface IVehicle {
  _id?: String | string
  name?: String
  code: String
  fleetVehicle: string | null
  nameFleetVehicle: string | null
  licensePlate: String
  price: Number | null
  driver: String | null
  driverName: String
  wattage: Number | null
  weight: Number | null
  numberOfCharge: Number | null
  wheel: Number | null
  vehicleLoad: number | null
  manufacture: String
  manufactureYear: Number | null
  manufactureAt: String
  buyingTime: Number | null
  expiredYear: Number | null
  vehicleType: String | null
  fuelVolume: Number | null
  oilVolume: Number | null
  registry: Date | String
  maintenanceSchedule: Array<IMaintenance>
  status: String
  type: number | null
  insurance: String
  fuelConsumption: Number | null
  sellingPrice: Number | null
  repairingPrice: Number | null
  depreciationVehicle: Number | null
  createdAt?: Date
  updatedAt?: Date
  vehicleTypeDetail: { [key: string]: any }
  driverDetail: { [key: string]: any }
  isGenset: Boolean | null
  containerType: Boolean | null
  coveringContainerLevel: String
  goodsType: Array<GoodsTypes> | Array<String> | []
  licenseType: String | string | null
  towingCapacity: Array<string | any>
  tollStation: Array<string | any>
  priceLiquidation: null | number
  typeFleetVehicle: Array<string> | null
  fleetVehicleDetail?: { [key: string]: any } | [] | null
  otherCompanyDriver?: {
    fullName: string
    phone: {
      countryCode: string
      phone: string
      code: string
    }
    idCardNumber: string
  }
  approvedByManagement?: boolean | null | undefined
}

const initFormVehicle = {
  name: '',
  code: '',
  licensePlate: '',
  fleetVehicle: null,
  nameFleetVehicle: null,
  price: null,
  driver: null,
  driverName: '',
  wattage: null,
  weight: null,
  numberOfCharge: null,
  wheel: null,
  vehicleLoad: null,
  manufacture: '',
  manufactureYear: null,
  manufactureAt: '',
  buyingTime: null,
  expiredYear: null,
  vehicleType: null,
  fuelVolume: null,
  oilVolume: null,
  registry: '',
  status: '',
  insurance: '',
  fuelConsumption: null,
  sellingPrice: null,
  repairingPrice: null,
  depreciationVehicle: null,
  vehicleTypeDetail: {} as { [key: string]: any },
  driverDetail: {} as { [key: string]: any },
  type: 0,
  isGenset: false,
  containerType: false,
  coveringContainerLevel: '',
  licenseType: '',
  towingCapacity: [],
  maintenanceSchedule: [],
  tollStation: [] as Array<{ [key: string]: any }>,
  goodsType: ['SOLID'],
  priceLiquidation: null,
  typeFleetVehicle: null,
  otherCompanyDriver: {
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    idCardNumber: ''
  }
}

const initVehicleCategory = {
  name: '',
  from: 0,
  to: null,
  wheelNumber: null,
  priceTires: null,
  depreciationTires: null,
  repairingPrice: null,
  liquidationValue: null,
  oilMaterialAssumption: null,
  insuranceValue: null,
  depreciationRate: null,
  description: ''
}

const initMaintenance = {
  from: 0,
  to: 0,
  value: 0
}
const initTollStationPrice = {
  tollStation: '',
  from: '',
  to: '',
  calculatedBy: null,
  tollStationName: ''
}

const rules = {
  addVehicleCategory: {
    'vehicleModule.category.categoryName': 'required',
    fromKg: 'required|integer',
    toKg: 'integer',
    'vehicleModule.category.wheelNumber': 'integer|min_value:1',
    'vehicleModule.category.depreciationTires': 'integer|min_value:1',
    liquidationValue: 'integer|min_value:1',
    oilMaterialAssumption: 'gt:0'
  },
  addVehicle: {
    'vehicleModule.licensePlate': 'required',
    'vehicleModule.price': 'required|integer',
    'vehicleModule.weight': 'required|integer',
    'driverModule.licenseType': 'required',
    'vehicleModule.buyingTime': 'required|integer|min_value:1970',
    'vehicleModule.expiredYear': 'required|integer|min_value:1970',
    'vehicleModule.category.vehicleLoad': 'required|integer',
    'vehicleModule.depreciationVehicle': 'integer|min_value:1'
  },
  editVehicle: {
    'vehicleModule.licensePlate': 'required',
    'vehicleModule.price': 'required|integer',
    'vehicleModule.weight': 'required|integer',
    'vehicleModule.buyingTime': 'integer|min_value:1970',
    'vehicleModule.expiredYear': 'integer|min_value:1970',
    'vehicleModule.category.vehicleLoad': 'required|integer',
    'vehicleModule.depreciationVehicle': 'integer|min_value:1'
  },
  addDocumentVehicle: {
    document: 'required|fileSize:10',
    documentType: 'required',
    expiredDate: 'invalidDateFormat',
    expiredDateRegistry: 'invalidDateFormat',
    insurancePrice: 'integer'
  },
  editDocumentVehicle: {
    documentType: 'required',
    expiredDate: 'invalidDateFormat',
    insurancePrice: 'integer'
  }
}
export default {
  initVehicleCategory,
  initFormVehicle,
  initMaintenance,
  initTollStationPrice,
  rules
}
